import React from 'react';
import { hydrateRoot } from 'react-dom/client';
import { I18nContextProvider, I18nInstanceType } from '@ecg-marktplaats/js-react-i18n';
import { Header } from '@hz-design-system/web-ui';

import AdmarktRegistration from '../../apps/AdmarktRegistration/AdmarktRegistration';

import '../../../scss/site/global/global.scss';

export default (i18n: I18nInstanceType) => {
  const appState = window.__CONFIG__ || {};
  const environment = window.__ENV_CONFIG__ || {};
  const headerConfig = window.__HEADER_CONFIG__ || {};
  const headerRootContainer = document.getElementById('header-root');
  const rootContainer = document.getElementById('root') as HTMLElement;

  hydrateRoot(headerRootContainer as HTMLElement, <Header headerConfig={headerConfig} />);

  hydrateRoot(
    rootContainer,
    <I18nContextProvider i18nInstance={i18n}>
      <AdmarktRegistration appState={appState} environment={environment} />
    </I18nContextProvider>,
  );
};
